export const WITHDRAWAL_SESSION_STORAGE_KEY = 'dashboard-withdrawal';
export const CURRENT_WALLET_SESSION_STORAGE_KEY = 'currentWalletAddress';
export const HAS_USER_BEEN_ONBOARDED_LOCAL_STORAGE_KEY = 'onboarded-user';
